import type { Rect } from "@aimosaic/core";

export type ResizeHandle = "nw" | "n" | "ne" | "e" | "se" | "s" | "sw" | "w";

const MIN_BOX_SIZE = 6;

export function resizeBoxFromHandle(
  box: Rect,
  handle: ResizeHandle,
  point: { x: number; y: number },
  imageWidth: number,
  imageHeight: number
): Rect {
  const clampedPoint = {
    x: clamp(point.x, 0, imageWidth),
    y: clamp(point.y, 0, imageHeight)
  };
  const left = box.x;
  const top = box.y;
  const right = box.x + box.width;
  const bottom = box.y + box.height;

  const nextLeft = handle.includes("w") ? clampedPoint.x : left;
  const nextRight = handle.includes("e") ? clampedPoint.x : right;
  const nextTop = handle.includes("n") ? clampedPoint.y : top;
  const nextBottom = handle.includes("s") ? clampedPoint.y : bottom;

  return clampEditableBox(
    {
      x: Math.min(nextLeft, nextRight),
      y: Math.min(nextTop, nextBottom),
      width: Math.abs(nextRight - nextLeft),
      height: Math.abs(nextBottom - nextTop)
    },
    imageWidth,
    imageHeight
  );
}

export function moveBoxByDelta(
  box: Rect,
  delta: { x: number; y: number },
  imageWidth: number,
  imageHeight: number
): Rect {
  const width = Math.min(Math.max(box.width, MIN_BOX_SIZE), imageWidth);
  const height = Math.min(Math.max(box.height, MIN_BOX_SIZE), imageHeight);
  return {
    x: clamp(box.x + delta.x, 0, imageWidth - width),
    y: clamp(box.y + delta.y, 0, imageHeight - height),
    width,
    height
  };
}

export function clampEditableBox(box: Rect, imageWidth: number, imageHeight: number): Rect {
  const width = Math.min(Math.max(box.width, MIN_BOX_SIZE), imageWidth);
  const height = Math.min(Math.max(box.height, MIN_BOX_SIZE), imageHeight);
  return {
    x: clamp(box.x, 0, imageWidth - width),
    y: clamp(box.y, 0, imageHeight - height),
    width,
    height
  };
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(Math.max(value, min), max);
}
